function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/heart/unfilled@svg");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/heart/unfilled",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "valentines-heart",
  transform: "translate(3.000000, 4.000000)",
  fillRule: "nonzero",
  stroke: "#DF6E4F",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M20,5.29959514 C20,4.42376003 19.7501794,2.82600594 19.3667969,2.09815116 C18.4689622,0.393604674 16.689292,0 14.5989905,0 C12.6512272,0 10.9502171,1.01502287 9.99993911,2.53194116 C9.04978294,1.01502287 7.07701961,0.568788533 5.12929688,0.568788533 C2.14642023,0.568788533 0,2.37266176 0,5.29959514 C0,6.89314599 0.719639389,8.3188142 1.85383555,9.2896658 C4.41489309,11.4223136 6.39733853,13.1774191 7.80117188,14.5549823 C8.09805999,14.8463147 8.66669674,15.5945526 9.50708213,16.7996959 C9.63778543,16.9279479 9.81504671,17 9.99993911,17 C10.1848315,17 10.3620928,16.9279479 10.4927961,16.7996959 C12.8796657,14.9971042 14.6392285,13.5402744 15.7714844,12.4292066 C16.3399499,11.8713788 17.1314693,10.8248652 18.1460427,9.2896658 C19.2802794,8.3188142 20,6.89314599 20,5.29959514 Z",
  id: "Shape"
})));

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.b2a268d3.svg";
export { ForwardRef as ReactComponent };